// src/user/LoginEmail.jsx
import React, { useState } from 'react';
import { useForm } from '../hooks/useForm';
import { Global } from '../helpers/Global';
import useAuth from '../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { ModalEULA } from './modalEULA';

export const LoginMail = () => {
  const { formulario, cambiado } = useForm();
  const [logeado, setLogeado] = useState("no_logeado");
  const [errorMsg, setErrorMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const [usuarioPendienteEULA, setUsuarioPendienteEULA] = useState(null);

  const logUser = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setErrorMsg("");

    // Normaliza email en el submit
    const payload = {
      email: (formulario.email || "").trim().toLowerCase(),
      password: formulario.password || ""
    };

    try {
      const request = await fetch(Global.url + 'usuarios/login-email', {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" }
      });

      const data = await request.json().catch(() => ({}));

      if (request.ok) {
        // Si falta EULA, guardamos token provisional
        if (!data.user?.eula_aceptado) {
          localStorage.setItem("token", data.token);
          setUsuarioPendienteEULA(data.user);
        } else {
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          setLogeado("logeado");
          setTimeout(() => {
            setAuth(data.user);
            navigate('/app/inicio', { replace: true });
          }, 600);
        }
      } else {
        setLogeado("error");
        setErrorMsg(data?.message || "Error en la identificación");
      }
    } catch (error) {
      console.error("Error al iniciar sesión (Email):", error);
      setLogeado("error");
      setErrorMsg("Error de conexión con el servidor");
    } finally {
      setIsSubmitting(false);
    }
  };

  const aceptarEULA = async () => {
    try {
      const request = await fetch(Global.url + "usuarios/eula", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      if (request.ok) {
        const updatedUser = { ...usuarioPendienteEULA, eula_aceptado: true };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setAuth(updatedUser);
        navigate('/app/inicio', { replace: true });
      } else {
        throw new Error("Error al aceptar el EULA");
      }
    } catch (error) {
      console.error("Error al aceptar EULA:", error);
      localStorage.clear();
      setUsuarioPendienteEULA(null);
      setLogeado("error");
      setErrorMsg("No se pudo registrar la aceptación del EULA");
    }
  };

  const rechazarEULA = () => {
    localStorage.clear();
    setUsuarioPendienteEULA(null);
    setLogeado("no_logeado");
  };

  return (
    <div className="layout_identificarse">
      <div>
        <h2>Iniciar sesión</h2>
        {logeado === "logeado" && (
          <strong className="success-message">Usuario identificado correctamente</strong>
        )}
        {logeado === "error" && (
          <strong className="error-message">{errorMsg || "Error en la identificación"}</strong>
        )}
      </div>

      <div className="content-form">
        <form className="form-login" onSubmit={logUser}>
          <div className="form-group">
            <FontAwesomeIcon className="icon-login" icon={faEnvelope} />
            <input
              className="input-layout"
              type="email"
              name="email"
              placeholder="Email"
              onChange={cambiado}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <FontAwesomeIcon className="icon-login" icon={faLock} />
            <input
              className="input-layout"
              type="password"
              name="password"
              placeholder="Contraseña"
              onChange={cambiado}
              autoComplete="current-password"
            />
          </div>

          <div>
            <input
              type="submit"
              value={isSubmitting ? "Entrando..." : "Identifícate"}
              className="btn btn-login"
              disabled={isSubmitting}
            />
            <div className="enlace-reset" style={{ marginTop: "10px", textAlign: "center" }}>
              <Link to="/olvide-password">¿Has olvidado tu contraseña?</Link>
            </div>
          </div>
        </form>
      </div>

      {usuarioPendienteEULA && (
        <ModalEULA onAccept={aceptarEULA} onReject={rechazarEULA} />
      )}
    </div>
  );
};
